import React, { useState } from 'react';
import { useAuth } from '../hooks/useAuth';
import { useBetConfig } from '../hooks/useBetConfig';
import { usePresets } from '../hooks/usePresets';
import AuthForm from './AuthForm';
import SimulationPage from './SimulationPage';

const BettingSimulator = () => {
  const [currentPage, setCurrentPage] = useState('auth');

  const {
    authConfig,
    setAuthConfig,
    authTokens,
    loading,
    results,
    errors,
    runFullAuth,
    getStepStatus,
    updateLoading,
    updateResult,
    updateError,
    clearError,
  } = useAuth();

  const { betBody, setBetBody, updateBetBodyForGame, simulateBet, resetToDefaults, exportConfig, importConfig } =
    useBetConfig(authConfig, authTokens, updateLoading, updateResult, updateError, clearError);

  const { presets, savePreset, loadPreset, deletePreset } = usePresets(betBody, setBetBody);

  const handleAuthSuccess = () => {
    setCurrentPage('simulation');
  };

  const handleGameChange = (gameId) => {
    updateBetBodyForGame(gameId);
  };

  const handleAuthSubmit = async () => {
    const success = await runFullAuth();
    if (success) {
      handleAuthSuccess();
    }
  };

  return (
    <div className="min-h-screen py-8 bg-gray-100">
      {currentPage === 'auth' ? (
        <AuthForm
          authConfig={authConfig}
          setAuthConfig={setAuthConfig}
          runFullAuth={handleAuthSubmit}
          loading={loading}
          onGameChange={handleGameChange}
        />
      ) : (
        <SimulationPage
          setCurrentPage={setCurrentPage}
          betBody={betBody}
          setBetBody={setBetBody}
          presets={presets}
          savePreset={savePreset}
          loadPreset={loadPreset}
          deletePreset={deletePreset}
          exportConfig={exportConfig}
          importConfig={importConfig}
          resetToDefaults={resetToDefaults}
          simulateBet={simulateBet}
          loading={loading}
          errors={errors}
          results={results}
          authTokens={authTokens}
          getStepStatus={getStepStatus}
        />
      )}
    </div>
  );
};

export default BettingSimulator;
